import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BotService } from 'src/app/core/services/bot.service';

@Component({
  selector: 'globot-list-steps-on-boarding',
  templateUrl: './list-steps-on-boarding.component.html',
  styleUrls: ['./list-steps-on-boarding.component.scss'],
})
export class ListStepsOnBoardingComponent implements OnInit {
  @Output() nextEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();

  haveBot: boolean = false;
  isMobile: boolean = false;

  // Define la variable 'events' aquí si es necesario
  events = [
    {
      status: 'Le pondrás un nombre a tu chatbot',
      text: 'Podrás cambiarlo después si lo deseas.',
      icon: 'pi pi-check',
      color: '#7B5CF5',
    },
    {
      status: 'Cargarás información de tu negocio',
      text: 'Puede ser tu sitio web, documentos o tu Google Drive.',
      icon: 'pi pi-check',
      color: '#7B5CF5',
    },
    {
      status: 'Escogerás una personalidad  ',
      text: 'Puedes escoger entre atención al cliente, Formal o Lúdico.',
      icon: 'pi pi-check',
      color: '#7B5CF5',
    },
    {
      status: '¡Listo!',
      text: 'Ya podrás conversar con tu asistente y agregarlo a tu sitio web.',
      icon: 'pi pi-check',
      color: '#7B5CF5',
    },
  ];

  constructor(private readonly botService: BotService) {
    this.haveBot = this.botService.haveBots();
  }

  ngOnInit(): void {
    //Verify mobile
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
  }

  next(): void {
    this.nextEvent.emit();
  }

  back(): void {
    this.backEvent.emit();
  }
}
